import { useKeycloak } from "@react-keycloak/web";
import React from "react";
import { Route } from "react-router";
import { RoleKey } from "../models/role";
import hasRoles from "./hasRoles";

export const RouterContentWrapper: React.FC<{ roles?: RoleKey[] }> = props => {
  const { keycloak } = useKeycloak();
  const isUserAuthorized = !props.roles || props.roles.length === 0 || hasRoles(props.roles, keycloak);
  if (props.roles && props.roles.length > 0 && !keycloak?.authenticated) {
    keycloak?.login();
  }
  return isUserAuthorized ? <>{props.children}</> : <p>403</p>;
};

const ControlledRoute: React.FC<{ exact?: boolean; path: string; roles?: RoleKey[] }> = ({ exact = true, path, roles, children }) => {
  return (
    <>
      <Route key={path} exact={exact} path={path}>
        <RouterContentWrapper roles={roles}>{children}</RouterContentWrapper>
      </Route>
    </>
  );
};

export default ControlledRoute;
